import {
  AccountBalance,
  AttachMoney,
  FactCheck,
  LocalHospital,
  TrendingUp,
} from '@mui/icons-material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import { SvgIconProps } from '@mui/material';
import React from 'react';
import AuthRedirectCallback from './components/auth-redirect-callback';
import { routes, text } from './constants';
import { Login } from './pages';
import { AccountingPage } from './pages/accounting-page';
import { BillingToolPage } from './pages/billing-tool-page';
import { EligibilityPage } from './pages/eligibility';
import { MemberAuthToolPage } from './pages/member-auth-tool.page';

import { HingeSelectPage } from './pages/hinge-select-page';
import { OtherRoles } from './pages/other-roles';
import { ROIPage } from './pages/roi-page';

export interface RouteDetails {
  path: string;
  menuPath?: string;
  label?: string;
  icon?: {
    svg?: React.ComponentType<SvgIconProps>;
    png?: string;
  };
  component: () => JSX.Element;
  splitFlag?: string;
}

export const authRoutes: RouteDetails[] = [
  {
    path: routes.auth_redirect_callback,
    component: AuthRedirectCallback,
  },
  {
    path: routes.login,
    component: Login,
  },
];

export const accountingRoutes: RouteDetails[] = [
  {
    path: routes.accounting,
    label: text.accounting.menuLabel,
    icon: { svg: AccountBalance },
    component: AccountingPage,
  },
];

export const billingToolRoutes: RouteDetails[] = [
  {
    path: routes.billing_tool,
    label: text.billing.menuLabel,
    icon: { svg: AttachMoney },
    component: BillingToolPage,
  },
];

export const hingeSelectRoutes: RouteDetails[] = [
  {
    path: routes.hinge_select,
    label: 'Hinge Select',
    icon: { svg: LocalHospital },
    component: HingeSelectPage,
  },
];

export const roiRoutes: RouteDetails[] = [
  {
    path: routes.roi,
    menuPath: routes.roi,
    label: text.roi.menuLabel,
    icon: { svg: TrendingUp },
    component: ROIPage,
  },
];

export const eligibilityRoutes: RouteDetails[] = [
  {
    path: routes.eligibility,
    label: text.eligibility.menuLabel,
    icon: { svg: FactCheck },
    component: EligibilityPage,
  },
];

export const memberAuthToolRoutes: RouteDetails[] = [
  {
    path: routes.member_auth,
    label: 'Member Auth Tool',
    icon: { svg: ManageAccountsIcon },
    component: MemberAuthToolPage,
  },
];

export const otherRoutes = [
  {
    path: routes.other,
    component: OtherRoles,
  },
];
